import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/Input';
import { formatPhone } from '@/lib/formatters';
import { normalizeUsPhone } from './phone';

interface PhoneInputProps {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  id?: string;
  autoFocus?: boolean;
}

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ value, onChange, disabled, placeholder = '555-123-4567', className, id, autoFocus }, ref) => {
    return (
      <Input
        ref={ref}
        id={id}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        autoFocus={autoFocus}
        placeholder={placeholder}
        value={formatPhone(value)}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => onChange(normalizeUsPhone(e.target.value))}
        className={cn('font-mono tracking-wide', className)}
      />
    );
  },
);
PhoneInput.displayName = 'PhoneInput';
